import {CheckboxTreeOptionType} from 'platform/components';

import {isNotNil, sum} from 'ramda';
import {ceil, isNilOrEmpty} from 'ramda-adjunct';

import {GetAllEnumsResponse} from '../../../types/api/api';

export const getOptionsCount = (items: CheckboxTreeOptionType[]): number =>
  sum(items.map((item) => (item.options?.length ? getOptionsCount(item.options) + 1 : 1)));

export const getRowOptions = (items: CheckboxTreeOptionType[]) => {
  const columnOptionsCount = ceil(getOptionsCount(items) / 2);

  const firstRow: CheckboxTreeOptionType[] = [];
  const secondRow: CheckboxTreeOptionType[] = [];
  let currentCount = 0;

  for (const item of items) {
    if (currentCount < columnOptionsCount) {
      firstRow.push(item);
    } else {
      secondRow.push(item);
    }
    currentCount += 1 + getOptionsCount(item.options ?? []);
  }

  return [firstRow, secondRow] as const;
};

export const getFilteredFeaturesWithParents = (
  items: GetAllEnumsResponse[number]['keys'],
  allItems: GetAllEnumsResponse[number]['keys']
): GetAllEnumsResponse[number]['keys'] => {
  if (isNilOrEmpty(items)) {
    return [];
  }

  const missingParent = items.filter(
    (item) => !items.some((otherItem) => otherItem.const_key === item.parent)
  );
  const missingParentItems = allItems.filter((item) =>
    missingParent.some((otherItem) => item.const_key === otherItem.parent)
  );

  return items.concat(getFilteredFeaturesWithParents(missingParentItems, allItems));
};

export const getTreeOptions = (
  items: GetAllEnumsResponse[number]['keys'],
  id?: string
): CheckboxTreeOptionType[] =>
  items
    ?.filter((item) => item.parent === (id ?? null))
    .map((item) => ({
      label: item.labels[0]?.label ?? item.const_key,
      value: item.const_key,
      options: getTreeOptions(items, item.const_key),
    })) ?? [];

export const filterFeaturesBySearch = (
  features: GetAllEnumsResponse[number]['keys'],
  searchValue: string | null
) =>
  searchValue
    ? features.filter((feature) => {
        const label = feature.labels[0]?.label;
        return (
          isNotNil(label) && label.toLocaleUpperCase().includes(searchValue.toLocaleUpperCase())
        );
      })
    : features;
